export type RovingKeys = 'vertical' | 'horizontal';

/**
 * The item that arrow / Home / End keys move to within a list (wrapping), or null for other keys.
 * `vertical` uses ArrowUp/ArrowDown (menus); `horizontal` uses ArrowLeft/ArrowRight (tab lists).
 */
export function nextRovingItem<T>(
  items: readonly T[],
  current: unknown,
  key: string,
  orientation: RovingKeys,
): T | null {
  if (!items.length) return null;
  const [previousKey, nextKey] = orientation === 'vertical' ? ['ArrowUp', 'ArrowDown'] : ['ArrowLeft', 'ArrowRight'];
  const index = items.findIndex((item) => item === current);
  switch (key) {
    case nextKey:
      return items[(index + 1) % items.length];
    case previousKey:
      return items[(index - 1 + items.length) % items.length];
    case 'Home':
      return items[0];
    case 'End':
      return items[items.length - 1];
    default:
      return null;
  }
}
